module.exports = __webpack_public_path__ + "img/fase3Debrief-play.130012df.jpg";